export function loadUniversignScript(endpoint) {
  if (window.universignSigInit) {
    return Promise.resolve();
  }

  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = `${endpoint}/sig/embed.js`;
    script.onload = resolve;
    script.onerror = () => reject(new Error('Failed to load Universign script'));
    document.head.appendChild(script);
  });
}

export function initSignature(containerId, signerId, endpoint) {
  if (!signerId) return Promise.resolve();

  return loadUniversignScript(endpoint).then(() => {
    if (window.universignSigInit) {
      window.universignSigInit(containerId, signerId, {}, endpoint);
    }
  });
}
